import React from 'react';

import {
  GoodfyndSiteContext,
  GoodfyndSiteDispatchContext,
} from './GoodfyndSiteContext';

export { default as GoodfyndSiteProvider } from './GoodfyndSiteContext';

export { GoodfyndSiteContext, GoodfyndSiteDispatchContext };

export function useGoodfyndSite() {
  const context = React.useContext(GoodfyndSiteContext);
  if (context === undefined) {
    throw new Error(
      'The useGoodfyndSite hook must be used within a GoodfyndSiteProvider.'
    );
  }
  return context;
}

export function useGoodfyndSiteDispatch() {
  const context = React.useContext(GoodfyndSiteDispatchContext);
  if (context === undefined) {
    throw new Error(
      'The useGoodfyndSiteDispatch hook must be used within a GoodfyndSiteProvider.'
    );
  }
  return context;
}
